import { TradeInAemContactFormId, type TradeInAemContactTextIdType } from "./constants";

export const prefillContactTextItemsData: Record<TradeInAemContactTextIdType, string> = {
    [TradeInAemContactFormId.FirstName]: "Test",
    [TradeInAemContactFormId.FirstLastName]: "Test",
    [TradeInAemContactFormId.SecondLastName]: "",
    [TradeInAemContactFormId.Address]: "Raymonde De Larochelaan",
    [TradeInAemContactFormId.HouseNumber]: "15",
    [TradeInAemContactFormId.PostalCode]: "9051",
    [TradeInAemContactFormId.City]: "Gent",
    [TradeInAemContactFormId.Email]: "test@external.toyota-europe.com", // Change this to your external e-mail for testing the leads locally
    [TradeInAemContactFormId.Phone]: "0123456789",
};
